import { X } from "lucide-react";
import { Badge } from "./primitives/badge";

/**
 * Quiet, always-visible signal that portfolio scoping is off (the "Show all
 * customers" override is on). Rendered as a sibling of the account-menu
 * trigger — not inside the dropdown — so it's readable with the menu closed,
 * and doubles as the way back to turning it off. Same Badge+dismiss shape
 * as `CustomerScopeChip` (the "filtered to one customer" precedent), kept
 * as its own component rather than a generalised prop on that one: the two
 * chips read opposite things (narrowed to one customer vs. scoping removed
 * entirely) and AccountMenu is this component's only caller.
 */
interface ScopeOverrideIndicatorProps {
  onDismiss: () => void;
}

export function ScopeOverrideIndicator({
  onDismiss,
}: ScopeOverrideIndicatorProps) {
  return (
    <Badge variant="secondary" className="gap-1 pr-1 text-sm font-normal h-7">
      <span>All customers</span>
      <button
        onClick={onDismiss}
        className="ml-0.5 rounded-sm hover:bg-muted transition-colors p-0.5"
        aria-label="Turn off Show all customers"
      >
        <X className="size-3" />
      </button>
    </Badge>
  );
}
